let baseUrl = '';
var env = process.env.NODE_ENV === 'development' ? 'development' :
    process.env.VUE_APP_TITLE === 'aplha' ? 'aplha' : 'production';

switch (env) {
    case 'development':
        baseUrl = 'http://106.53.30.65:81/' // bendi 
        break;
    case 'aplha':
        baseUrl = 'http://192.168.0.2/'
        break;
    case 'production':
        baseUrl = 'http://106.53.30.65:81/' // shengchan
        // baseUrl = ''
        break;
}

export default baseUrl;